import React from 'react';
import { styled } from 'styled-components';

interface Group {
	id: string;
	name: string;
}

interface GroupsCellProps {
	groups: Group[];
}

export default function GroupsCell({ groups }: GroupsCellProps) {
	const maxVisibleGroups = 2; // Show max 2 groups, then +N for the rest

	if (!groups || groups.length === 0) {
		return <span>-</span>;
	}

	const visibleGroups = groups.slice(0, maxVisibleGroups);
	const remainingCount = groups.length - maxVisibleGroups;

	return (
		<GroupsContainer>
			{visibleGroups.map((group) => (
				<GroupChip key={group.id}>
					<GroupChipText>{group.name}</GroupChipText>
				</GroupChip>
			))}
			{remainingCount > 0 && (
				<OverflowChip>+{remainingCount}</OverflowChip>
			)}
		</GroupsContainer>
	);
}

const GroupsContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
	align-items: center;
	flex-wrap: wrap;
	padding-top: 8px;
	padding-bottom: 8px;
	height: 100%;
`;

const GroupChip = styled.div`
	color: white;
	border: 1px solid ${({ theme }) => theme.palette.grey[600]};
	border-radius: 20px;
	padding: 6px 16px;
	font-size: 14px;
	font-weight: 500;
	height: 100%;
	display: flex;
	align-items: center;
	max-width: 140px;
`;

const GroupChipText = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	min-width: 0;
`;

const OverflowChip = styled.div`
	color: white;
	border: 1px solid ${({ theme }) => theme.palette.grey[600]};
	border-radius: 20px;
	padding: 6px 12px;
	font-size: 14px;
	font-weight: 500;
	white-space: nowrap;
	height: 100%;
	align-items: center;
	display: flex;
`;
